export const UPGRADED_HULL = 'Upgraded hull';
export const UPGRADED_HULL_POINTS = 50;

export const extraEquipment = [UPGRADED_HULL] as const;

export type ExtraEquipment = typeof extraEquipment[number];
